module.exports = __webpack_public_path__ + "static/media/export-data.0d0093c7.jpg";